(function () {
  'use strict';

  angular.module('app').component('clientProfileList', clientProfileList());

  function clientProfileList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
      },
      controller: ClientProfileListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/client-profiles/client-profile-list/client-profile-list.component.html',
    };
  }

  ClientProfileListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'ClientProfileService',
    'PriceListService',
  ];

  function ClientProfileListComponent(
    config,
    UtilService,
    AbilityService,
    ClientProfileService,
    PriceListService
  ) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_clientprofile_accountadmin'),
      canUpdate: AbilityService.can('update_clientprofile_accountadmin'),
      canDestroy: AbilityService.can('destroy_clientprofile_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = ClientProfileService.getFilterCriteria();

    vm.dateDisplay = config.DATE_DISPLAY;

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemDefault = changeItemDefault;

    vm.$onInit = function () {
      checkDefaultClientProfile(vm.items);

      // Initializers
      getPriceLists();
    };

    function getPriceLists() {
      var params = {
        get: 'active',
        contact_type: 'client',
        skip_check_role: true,
      };

      PriceListService.getPriceLists(params).then(function (data) {
        vm.priceLists = data.items;
      });
    }

    function fetchResult() {
      vm.loadingItems = true;
      ClientProfileService.getClientProfiles(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        checkDefaultClientProfile(vm.items);

        vm.loadingItems = false;
        vm.showActions = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = ClientProfileService.getFilterCriteria();
      fetchResult();
    }

    function selectPage(page) {
      vm.filterCriteria.page = page;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item) {
      if (!vm.permissions.canShow) {
        return;
      }
      vm.onShowItem({ item: item });
    }

    function deleteItem(item) {
      ClientProfileService.deleteClientProfile(item, fetchResult);
    }

    function changeItemDefault(item) {
      ClientProfileService.changeClientProfileDefault(item, fetchResult);
    }

    function checkDefaultClientProfile(items) {
      var found = false;

      for (var i = 0; i < items.length; i++) {
        var clientProfile = items[i];
        if (clientProfile.is_default) {
          found = true;
          break;
        }
      }

      vm.noDefaultClientProfile = !found;
    }
  }
})();
